import { render, staticRenderFns } from "./IdeaDialog.vue?vue&type=template&id=1c0f7442&scoped=true&"
import script from "./IdeaDialog.vue?vue&type=script&lang=js&"
export * from "./IdeaDialog.vue?vue&type=script&lang=js&"
import style0 from "./IdeaDialog.vue?vue&type=style&index=0&id=1c0f7442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f7442",
  null
  
)

export default component.exports